import { render, staticRenderFns } from "./numbers.vue?vue&type=template&id=a0b711f2&scoped=true&"
import script from "./numbers.vue?vue&type=script&lang=js&"
export * from "./numbers.vue?vue&type=script&lang=js&"
import style0 from "./numbers.vue?vue&type=style&index=0&id=a0b711f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b711f2",
  null
  
)

export default component.exports